<template>
  <div class="min-h-screen bg-gradient-to-br from-[#2a0d4f] via-[#1b1240] to-[#0f172a] text-white">

    <!-- NAVBAR -->

    <header class="sm:flex sm:justify-between sm:items-center sm:px-1 sm:py-1">
      <div class="flex items-center justify-between px-4 py-2 sm:p-0">
        <div>
          <img class="p-5" src="/images/logo.webp" alt="Links Digest" />
        </div>
        <div class="sm:hidden">
          <button @click="data.isOpen = !data.isOpen" type="button" aria-label="More Options" class="block text-gray-500 hover:text-white focus:text-white focus:outline-none">
            <svg class="h-6 w-6 fill-current" viewBox="0 0 24 24">
              <path v-if="data.isOpen" fill-rule="evenodd" d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"/>
              <path v-if="!data.isOpen" fill-rule="evenodd" d="M4 5h16a1 1 0 0 1 0 2H4a1 1 0 1 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2zm0 6h16a1 1 0 0 1 0 2H4a1 1 0 0 1 0-2z"/>
            </svg>
          </button>
        </div>
      </div>
      <nav :class="data.isOpen ? 'block' : 'hidden'" class=" px-2 pt-2 pb-4 sm:flex sm:m-3 text-sm text-end text-white/70">
        <a target="_blank" 
          href="https://www.instagram.com/linksdigest/"
          class="group mt-1 hover:bg-white/10 rounded-xl p-2 hover:text-cyan-400">
          <svg width="24px" class="fill-white group-hover:fill-cyan-400 pt-1"  height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z" />
            <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z" />
          </svg>

          <!-- <svg fill="none" class="fill-white group-hover:fill-cyan-400" width="24px" height="24px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>tiktok</title>
            <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path>
          </svg> -->
        </a>
        <a target="_blank" 
          href="https://tiktok.com/@linksdigest"
          class="group mt-1 hover:bg-white/10 rounded-xl p-2 hover:text-cyan-400">
          <svg fill="none" class="fill-white group-hover:fill-cyan-400 pt-1" width="22px" height="22px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <title>tiktok</title>
            <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path>
          </svg>
        </a>
        <button
          style="margin-left: auto; font-weight: 500;"
          @click="showContactUs = true"
          class="block mt-1 me-3 p-3 rounded-xl hover:bg-white/10 hover:text-cyan-400">
          Contact Us
        </button>
        <button
          style="margin-left: auto; font-weight: 500;"
          @click="showModal = true"
          :class="data.isOpen ? 'mt-2' : 'mt-1' "
          class="block  me-3 p-3 rounded-xl text-[#0f172a] bg-cyan-400 hover:bg-white/10 hover:text-cyan-400 ">
          Suggest
      </button>
      </nav>
    </header>

    <!-- HERO -->
    <section class="text-center px-6 mt-2">
      <h1 class="text-4xl md:text-6xl font-extrabold tracking-tight">
        Links for <span class="text-cyan-400">curious minds</span>
      </h1>

      <h2 class="mt-5 text-white/70 max-w-2xl mx-auto">
        A collection of the best links related to technology, AI, development, UX/UI, and digital creativity, among other topics.
      </h2>

      <!-- SEARCH -->
      <div class="mt-8 max-w-xl mx-auto">
        <input
          type="text"
          placeholder="Search links, topics or tools..."
          @keyup="onSearchChange"
          v-model="data.search"
          class="w-full rounded-xl bg-white/10 backdrop-blur px-5 py-4
                 placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-cyan-400"
        />
      </div>
    </section>

    <!-- CATEGORIES -->
    <section class="mt-10 px-8 max-w-6xl mx-auto">
      <h2 class="text-lg uppercase tracking-widest text-white/50 mb-6">
        Categories
      </h2>

      <div v-if="data.isLoadingCategories">Loading...</div>
      <div v-if="!data.isLoadingCategories" class="grid sm:grid-cols-1 md:grid-cols-5 gap-4">
        <CategoryCard @click="changeActive(value.name)" v-for="value in data.categories" :active="data.activeCategories.indexOf(value.name) >= 0" :key="value" :title="value.name" />
      </div>
    </section>

    <!-- FEATURED LINKS -->
    <section class="mt-10 px-8 max-w-6xl mx-auto">
      <h2 class="text-lg uppercase tracking-widest text-white/50 mb-6">
        Featured Links
      </h2>

      <div class="grid md:grid-cols-1 gap-3">
          <LinkCard 
            v-for="value in data.links" :key="value._id"
            :title="value.title"
            :description="value.description"
            :tags="value.tags"
            :image="formatUrl(value.images[0])"
            :url="value.url"
          />
      </div>
      <div v-if="data.isLoading">Loading...</div>
    </section>

    <!-- FOOTER -->
    <footer class="mt-16 py-10 text-center text-white/40 text-sm">
      <span>© {{ new Date().getFullYear() }} linksdigest.com - For curious minds by </span>
      <span><a href="https://lazulilabs.com" class="hover:text-white">lazulilabs.com</a></span>
      <span> - <a href="/terms" class="hover:text-white">Terms & Conditions</a></span>
      <span> - <a href="/privacy" class="hover:text-white">Privacy</a></span>
    </footer>
    <AddLinkModal
      :open="showModal"
      @close="showModal = false"
    />
    <ContactUs
      :open="showContactUs"
      @close="showContactUs = false"
    />
  </div>
</template>

<script lang="ts">
import { onMounted, onUnmounted, reactive, ref } from "vue";
import { formatUrl } from "@/utils/url.utils";
import linkService from "@/services/link.service";
import categoryService from "@/services/category.service";
import CategoryCard from "@/components/CategoryCard.vue"
import LinkCard from "@/components/LinkCard.vue"
import ContactUs from "@/components/ContactUs.vue"
import AddLinkModal from "@/components/AddLinkModal.vue"

export default {
  name: "HomeView",
  components: {
    AddLinkModal,
    CategoryCard,
    LinkCard,
    ContactUs
  },
  setup() {
    var data = reactive({
      links: [] as Array<any>,
      categories: [] as Array<any>,
      activeCategories: [] as Array<string>,
      isLoading: false,
      isLoadingCategories: false,
      noMoreData: false,
      search: "",
      isOpen: false
    });

    const showModal = ref(false);
    const showContactUs = ref(false);

    const getData = (skip: number, items: number, reset: boolean) => {
      try {
        if (data.isLoading)
          return;
        
        data.isLoading = true;
        if (reset)
          data.links = [];
        linkService.getActiveLinks(skip, items, data.search, data.activeCategories).then((response: any) => {
          if (response && response.data && response.data.data) {
            if (response.data.data.length == 0) {
              data.noMoreData = true;
            } 
            response.data.data.forEach((item) => {
              data.links.push(item);
            })
            data.isLoading = false
          }
        })
      } catch (e) {
        console.log("error getting data", e)
        data.isLoading = false
        
      }
        

    }

    const handleScroll = (e) => {
      if (data.noMoreData)
        return;

      if (window.scrollY > 0 && window.scrollY > window.innerHeight) {
        getData(data.links.length, 20, false)
      }
    }

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll)
    })

    onMounted(async () => {
      try {
        data.isLoadingCategories = true
        categoryService.getPublishedItems(0, 20).then((response: any) => {
          if (response && response.data && response.data.data) {
            data.categories = response.data.data
            data.isLoadingCategories = false
          }
        })

        getData(0, 20, false)
        window.addEventListener("scroll", handleScroll) 
      } catch {
        console.debug("error getting samples")
      }
    });

    const changeActive = ((key) => {
      const index = data.activeCategories.indexOf(key);
      if (index == -1) {
        data.activeCategories.push(key);
      } else {
        data.activeCategories.splice(index, 1);
      }
      getData(0, 20, true);
        
    })

    let interval;
    const onSearchChange = (() => {
      
      clearInterval(interval);
      interval = setTimeout(() =>{
        getData(0, 20, true);
      }, 1000)
    })
    return { data, showModal, showContactUs, formatUrl, onSearchChange, changeActive };
  },
};
</script>